import axios from 'axios'

const axiosHttp = axios.create({
  timeout: 30000,
})

export default axiosHttp
